import React from 'react';
import { Link } from 'react-router-dom';
import { Eyebrow } from './ui';
import { APP_STORE_URL, PLAY_STORE_URL } from './appLinks';
import SocialLinks from './SocialLinks';
import { CITY_PAGES, SERVICE_PAGES } from './pages/landing';

const PHONE_DISPLAY = '+1 929-231-5951';
const PHONE_HREF = 'tel:+19292315951';
const EMAIL = 'service@rooldrive.com';

export default function SiteFooter() {
  return (
    <footer className="lx-footer">
      <div className="lx-container">
        <div className="lx-footer-grid">
          <div className="lx-footer-brand lx-stack">
            <Link to="/" className="lx-wordmark">Rool<span>Drive</span></Link>
            <p className="lx-muted" style={{ maxWidth: 340, margin: 0, fontSize: 15 }}>
              Private chauffeur service across New York. Airport transfers, hourly service and
              point-to-point rides, with a professional chauffeur every time.
            </p>
            <SocialLinks />
          </div>

          <div>
            <Eyebrow className="lx-footer-title">Ride</Eyebrow>
            <ul className="lx-footer-links">
              <li><Link to="/book">Book a ride</Link></li>
              <li><Link to="/dashboard/bookings">My rides</Link></li>
              <li><Link to="/help">Help center</Link></li>
              <li><a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">iPhone app</a></li>
              <li><a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">Android app</a></li>
            </ul>
          </div>

          <div>
            <Eyebrow className="lx-footer-title">Airports</Eyebrow>
            <ul className="lx-footer-links">
              <li><Link to="/jfk-car-service">JFK car service</Link></li>
              <li><Link to="/laguardia-car-service">LaGuardia car service</Link></li>
              <li><Link to="/newark-airport-car-service">Newark car service</Link></li>
              <li><Link to="/airport-transfers">All airport transfers</Link></li>
            </ul>
          </div>

          <div>
            <Eyebrow className="lx-footer-title">Services</Eyebrow>
            <ul className="lx-footer-links">
              {SERVICE_PAGES.map((p) => <li key={p.path}><Link to={p.path}>{p.linkText}</Link></li>)}
            </ul>
          </div>

          <div>
            <Eyebrow className="lx-footer-title">Popular routes</Eyebrow>
            <ul className="lx-footer-links">
              {CITY_PAGES.map((p) => <li key={p.path}><Link to={p.path}>{p.linkText}</Link></li>)}
            </ul>
          </div>

          <div>
            <Eyebrow className="lx-footer-title">Company</Eyebrow>
            <ul className="lx-footer-links">
              <li><Link to="/about">About us</Link></li>
              <li><Link to="/fleet">Our fleet</Link></li>
              <li><Link to="/guides">Travel guides</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/terms">Terms of service</Link></li>
              <li><Link to="/privacy">Privacy policy</Link></li>
            </ul>
          </div>

          <div>
            <Eyebrow className="lx-footer-title">Contact</Eyebrow>
            <ul className="lx-footer-links">
              <li><a href={PHONE_HREF}>{PHONE_DISPLAY}</a></li>
              <li><a href={`mailto:${EMAIL}`}>{EMAIL}</a></li>
              <li><span className="lx-muted" style={{ fontSize: 14 }}>New York, NY</span></li>
            </ul>
          </div>
        </div>

        <div className="lx-footer-bottom">
          <span>© {new Date().getFullYear()} RoolDrive. All rights reserved.</span>
          <span>All pickup times are New York time.</span>
        </div>
      </div>
    </footer>
  );
}
